import { render } from "./Certifications.vue?vue&type=template&id=0b19b54b&scoped=true"
import script from "./Certifications.vue?vue&type=script&lang=js"
export * from "./Certifications.vue?vue&type=script&lang=js"

import "./Certifications.vue?vue&type=style&index=0&id=0b19b54b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b19b54b"]])

export default __exports__